/**
 * Checks if window is defined
 *
 * @returns {boolean} true if window is defined, false otherwise
 */
var isWindowDefined = typeof window !== 'undefined';
export default isWindowDefined;